import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { LanguageHandlerService } from 'src/app/services/language-handler.service';
import { APIConfigService } from 'src/app/services/api-config.service';
import { iterateAPIConfig } from 'src/app/helpers/api-resp-helper';
import { cacheKeys } from 'src/app/constants/cache-keys';
import { PageAPIResp } from 'src/app/models/api-config.model';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  cacheKeys = cacheKeys;
  allAPIsResp: PageAPIResp = {};
  private langChangeSubs!: Subscription;
  private title = 'UMANG - One App, Many Government Services';
  private description =
    'UMANG provides a single platform for all Indian Citizens to access pan India e-Gov services ranging from Central to Local Government bodies.';

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private langHandlerService: LanguageHandlerService,
    private apiConfigService: APIConfigService,
    private storeService:StoreService
  ) {}

  ngOnInit() {
    this.setTitleAndMeta();
    iterateAPIConfig(
      this.apiConfigService.getHomePageConfig(),
      this.allAPIsResp
    );
    this.addLangChangeListener();
  }

  private setTitleAndMeta() {
    this.titleService.setTitle(this.title);
    this.metaService.updateTag({
      name: 'description',
      content: this.description,
    });
  }

  private addLangChangeListener() {
    this.langChangeSubs = this.langHandlerService.onLangChange.subscribe(() => {
      iterateAPIConfig(
        this.apiConfigService.getHomePageConfig(),
        this.allAPIsResp
      );
    });
  }

  ngOnDestroy() {
    this.langChangeSubs?.unsubscribe();
  }
}
